import { HttpErrorResponse } from '@angular/common/http';
import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable()
export class ToastService {

  constructor(
    private messageService: MessageService) {}

  showError(error: any) {
    if (error) {
      if (typeof(error) === 'string') {
        this.messageService.add(
          {
            severity: 'error',
            summary: 'Error',
            detail: error,
            life: 5000
        });
      }
      else if (error instanceof HttpErrorResponse) {
        if (error.status > 0) {
          this.messageService.add(
            {
              severity: 'error',
              summary: 'Server Error',
              detail: error.status + " (" + error.statusText + "): " + error.error,
              life: 5000
          });
        }
        else if (error.status === 0) {
          this.messageService.add(
            {
              severity: 'error',
              summary: 'Network Error',
              detail: 'A critical network communication error has occured.  Please try again.',
              life: 5000
          });
        }
      }
      else {
        this.messageService.add(
          {
            severity: 'error',
            summary: 'Error',
            detail: 'An unknown error has occured: ' + error,
            life: 5000
        });
      }
    }
  }

  showInformation(text: string) {
    this.messageService.add(
      {
        severity: 'info',
        summary: 'Information',
        detail: text,
        life: 10000
      });
  }

  showWarning(text: string) {
    this.messageService.add(
      {
        severity: 'warn',
        summary: 'Warning',
        detail: text,
        life: 10000
      });
  }

  showSuccess(text: string) {
    this.messageService.add(
      {
        severity: 'success',
        summary: 'Success',
        detail: text,
        life: 8000
      });
  }

}
